import { useEffect, useState } from "react";
import { UNDO_DURATION_MS } from "../lib/constants.js";
import styles from "./UndoToast.module.css";

interface UndoItem {
  itemId: string;
  text: string;
  expiresAt: number;
}

interface Props {
  item: UndoItem;
  onUndo: (itemId: string) => void;
  onExpire: (itemId: string) => void;
}

export function UndoToast({ item, onUndo, onExpire }: Props) {
  const [remaining, setRemaining] = useState(Math.max(0, item.expiresAt - Date.now()));

  useEffect(() => {
    const interval = setInterval(() => {
      const left = Math.max(0, item.expiresAt - Date.now());
      setRemaining(left);
      if (left <= 0) {
        clearInterval(interval);
        onExpire(item.itemId);
      }
    }, 100);

    return () => clearInterval(interval);
  }, [item.expiresAt, item.itemId, onExpire]);

  const seconds = Math.ceil(remaining / 1000);
  const progress = remaining / UNDO_DURATION_MS;

  return (
    <output className={styles.toast} aria-live="polite">
      <span className={styles.text}>
        「{item.text}」を削除しました（{seconds}秒）
      </span>
      <button type="button" className={styles.button} onClick={() => onUndo(item.itemId)}>
        元に戻す
      </button>
      <div className={styles.progress} style={{ width: `${progress * 100}%` }} />
    </output>
  );
}

export type { UndoItem };
